/**
 * AuthContainer
 * --
 */
import React, { useEffect } from 'react';
import AuthPresenter from './AuthPresenter';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { removeCookie, deleteCookie, getCookie } from 'utils';
import { useUserAction } from 'store';
import { useAuthCheck } from 'hooks/AuthHooks';

const AuthContainer = () => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paramsToken = searchParams.get('token');

  /* ===== Actions ===== */
  const userAction = useUserAction();

  /* ===== Mutate ===== */
  const { authCheck } = useAuthCheck();

  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [isRender, setIsRender] = React.useState(false);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 토큰, 스토어 저장 후 라우팅 처리
   * --
   */
  const handleRouting = (path) => {
    navigate(`${path}`, { replace: 'true' });
  };

  /**
   * 인증 토큰 검사
   * --
   */
  const handleTokenCheck = async () => {
    // 토큰 검증
    const { status, data } = await authCheck();

    // NOTE: 검증 실패 처리
    if (status !== 200) {
      userAction.resetUser();
      deleteCookie('JM_COFFEE_ACCESS_TOKEN', {});
      return;
    }

    // NOTE: 검증 성공
    userAction.setUser(data); // 토큰 검증 데이터 스토어에 저장

    const { shop_information_id } = data;

    if (!shop_information_id) {
      // NOTE: JM 정보를 입력하지 않은 최종관리자 (최초 로그인일 경우)
      handleRouting(`/apply`);
    } else {
      // NOTE: 쇼핑몰 정보를 입력하였을 경우
      handleRouting(`/main`);
    }
  };

  /* ===== HOOKS ===== */
  /**
   * 쿼리로 받은 토큰 쿠키 저장
   * --
   */
  useEffect(() => {
    if (paramsToken) {
      // NOTE: 쿠키 저장 시간 설정
      const saveTime = 8 * 60 * 60 * 1000; // 8h
      removeCookie('JM_COFFEE_ACCESS_TOKEN', paramsToken, saveTime);

      setIsRender(true);
    }
  }, [paramsToken]);

  /**
   * 토큰 저장 후 검증 처리
   * --
   */
  useEffect(() => {
    const token = getCookie('JM_COFFEE_ACCESS_TOKEN');
    if (isRender && token) {
      handleTokenCheck();
    }
    // eslint-disable-next-line
  }, [isRender]);

  /* ===== RENDER ===== */
  return (
    <>
      <AuthPresenter />
    </>
  );
};

export default AuthContainer;
